export { default } from '@/shared/components/FormModal';
export type { FormModalProps } from '@/shared/components/FormModal';
